import React from 'react';
import {
  DEFAULT_ASSET_LABELS,
  getContentLabels,
  getAdLabels,
  getVideoMetrixLabels
} from './helper';

// comscore publisher ID
export const PUBLISHER_ID = '14868646';

let _isScriptInHead = false;

// private var to hold single global comscore streaming analytics instance
let _sa;

class Comscore extends React.Component {
  componentDidMount() {
    // Only append script once
    if (_isScriptInHead === false) {
      // Note, the script must be appended to the document instead of using
      // <Head> since we need to respond to the load event.
      const script = document.createElement('script');
      script.src = '/static/comscore.streaming.5.4.3.161125.min.js';
      script.async = true;
      script.onload = this.constructor.initialize;
      document.head.appendChild(script);
      _isScriptInHead = true;
    }
  }

  render() {
    return null;
  }
}

Comscore.initialize = () => {
  _sa =
    _sa ||
    new window.ns_.StreamingAnalytics({
      publisherId: PUBLISHER_ID
    });
};

Comscore.notify = (evt, position) => {
  _sa[`notify${evt}`](position);
};

Comscore.createPlaybackSession = () => {
  _sa.createPlaybackSession();
};

Comscore.getCurrentAssetId = () =>
  _sa
    .getPlaybackSession()
    .getAsset()
    .getLabel('ns_st_ci');

Comscore.setCurrentAsset = (asset, type, category) => {
  const metadata = Object.assign(
    {},
    DEFAULT_ASSET_LABELS,
    getVideoMetrixLabels(category),
    type === 'content' ? getContentLabels(asset) : getAdLabels(asset)
  );

  _sa.getPlaybackSession().setAsset(metadata);
};

export default Comscore;
